<script>
import { authMethods } from '@state/helpers'
import layout from '@src/mixins/layout.vue'

export default {
  mixins: [layout],
  methods: {
    ...authMethods,
    async goToDashboardScreen() {
      await this.updateUserSettings({ welcomed: true })
      this.$emit('update:value', false)
      this.$router.push({ name: 'safehaven-dashboard' })
    },
  },
}
</script>

<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col
          cols="12"
          md="12"
          :class="$style.mainContainer"
          :style="
            notDesktop ? 'align-items: center' : 'align-items: flex-start'
          "
        >
          <p :class="$style.title">Thank you!</p>
          <p :class="$style.descriptionText">
            This helps us to get to know you better and how we can better serve
            your health needs.
          </p>
          <v-btn
            class="text-capitalize"
            rounded
            :width="notDesktop ? '330px' : '271px'"
            height="45px"
            :class="$style.returnButton"
            @click="goToDashboardScreen"
          >
            Return to dashboard
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<style lang="scss" module>
@import '@design';

.title {
  font-size: 28px;
  font-weight: 400;
  line-height: 38px;
  color: #000;
  text-align: center;
  letter-spacing: -0.30000001192092896px;
}

.descriptionText {
  font-size: 15px;
  font-weight: 400;
  line-height: 23px;
  color: #000;
  text-align: center;
  letter-spacing: 0;
}

.returnButton {
  margin-top: 25px;
  font-size: 18px !important;
  font-weight: 600;
  line-height: 27px;
  color: #fff !important;
  text-align: center;
  letter-spacing: 0;
  background-color: #0476d9 !important;
  border-radius: 32px;
}

.mainContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px 10px;
}
</style>
